var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_INDUSTRY_IMAGE_REQUEST, GET_INDUSTRY_IMAGE_SUCCESS, GET_INDUSTRY_IMAGE_ERROR } from '../actions/getIndustryImage';
var initialState = {
    isFetching: false,
    isError: false,
    image: ''
};
export function getIndustryImage(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_INDUSTRY_IMAGE_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_INDUSTRY_IMAGE_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, image: action.payload.data });
        case GET_INDUSTRY_IMAGE_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=getIndustryImage.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_INDUSTRY_IMAGE_REQUEST, GET_INDUSTRY_IMAGE_SUCCESS, GET_INDUSTRY_IMAGE_ERROR } from '../actions/getIndustryImage';
var initialState = {
    isFetching: false,
    isError: false,
    image: ''
};
export function getIndustryImage(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_INDUSTRY_IMAGE_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_INDUSTRY_IMAGE_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, image: action.payload.data });
        case GET_INDUSTRY_IMAGE_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=getIndustryImage.js.map